var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid container_gallery"},[_c('nav-tab'),_c('grid-gallery',{on:{"openImg":function($event){return _vm.openPopUp($event)}}}),_c('modal',{staticClass:"modal_gallery",attrs:{"name":"modal_gallery","draggable":".window-header","height":"auto"}},[_c('pop-modal')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }